// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';

document.addEventListener('DOMContentLoaded', () => {
  // レベルパターン選択の場合、子（レベル）の選択状態を設定/解除を行う
  $('input[name="flower_patterns_id_in[]"]').click((e) => {
    const parentElement = e.target.closest('div');
    parentElement.querySelectorAll('input[name="q[levels_id_in][]"]').forEach((el) => {
      el.checked = e.target.checked;
    });
  });

  // レベル選択の場合、親(レベルパターン)の選択状態を設定/解除を行う
  $('input[name="q[levels_id_in][]"]').click((e) => {
    const flowerPatternId = e.target.dataset.flowerPatternId;
    const checkBoxes = document.querySelectorAll(`[data-flower-pattern-id="${flowerPatternId}"]`);
    const allChecked = Array.from(checkBoxes).every((checkbox) => checkbox.checked);
    document.getElementById(`flower_pattern_id_${flowerPatternId}`).checked = allChecked;
  });
});
